/* Anne Bloom theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var AB = window.AB || {};
  var root = (AB.routes && AB.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  function qs(s, el) { return (el || document).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function fmt(cents) {
    var f = (AB.moneyFormat || '£{{amount}}');
    var v = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
  }

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var o = document.getElementById(id);
    if (!o) return;
    lastFocus = document.activeElement;
    o.setAttribute('data-open', '');
    o.removeAttribute('aria-hidden');
    document.body.classList.add('ab-lock');
    var f = qs('[data-autofocus], button, a, input', o.querySelector('.ab-drawer') || o);
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawer(o) {
    if (!o) return;
    o.removeAttribute('data-open');
    o.setAttribute('aria-hidden', 'true');
    if (!qs('.ab-overlay[data-open]')) document.body.classList.remove('ab-lock');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-open-drawer')); return; }
    var closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.ab-overlay')); return; }
    if (e.target.classList && e.target.classList.contains('ab-overlay')) closeDrawer(e.target);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') qsa('.ab-overlay[data-open]').forEach(closeDrawer);
  });

  /* ---------- cart ---------- */
  function refreshCart(open) {
    return fetch(root + '?sections=cart-drawer,cart-count')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        if (data['cart-drawer']) {
          tmp.innerHTML = data['cart-drawer'];
          var fresh = qs('#CartDrawer', tmp), cur = document.getElementById('CartDrawer');
          if (fresh && cur) {
            var wasOpen = cur.hasAttribute('data-open');
            cur.innerHTML = fresh.innerHTML;
            if (wasOpen) cur.setAttribute('data-open', '');
          }
        }
        if (data['cart-count']) {
          tmp.innerHTML = data['cart-count'];
          var n = qs('[data-cart-count]', tmp);
          qsa('[data-cart-count]').forEach(function (el) { el.outerHTML = n ? n.outerHTML : ''; });
        }
        if (open) openDrawer('CartDrawer');
      });
  }

  function cartChange(line, qty) {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('is-loading');
    return fetch(AB.routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshCart(false);
    }).finally(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    e.preventDefault();
    cartChange(parseInt(b.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-line-change'), 10));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ab-add]');
    if (!form || AB.cartType === 'page') return;
    e.preventDefault();
    var btn = qs('[type="submit"]', form), err = qs('[data-form-error]', form);
    if (btn) btn.classList.add('is-loading');
    if (err) err.textContent = '';
    fetch(AB.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (err) err.textContent = res.j.description || res.j.message || 'Could not add to bag'; return; }
        return refreshCart(true);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  /* quick add from product cards: size buttons carry a variant id */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    q.classList.add('is-loading');
    fetch(AB.routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(q.getAttribute('data-quick-add'), 10), quantity: 1 }] })
    }).then(function () { return refreshCart(true); })
      .finally(function () { q.classList.remove('is-loading'); });
  });

  /* ---------- variant picker ---------- */
  qsa('[data-product-form]').forEach(function (wrap) {
    var dataEl = qs('script[data-product-json]', wrap);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = qs('form[data-ab-add]', wrap);
    var idInput = qs('input[name="id"]', form);
    var priceEl = qs('[data-price]', wrap);
    var btn = qs('[data-add-button]', wrap);
    var stickyBtn = qs('[data-sticky-add]');
    var stock = qs('[data-stock]', wrap);

    function selected() {
      return product.options.map(function (_, i) {
        var c = qs('input[data-option-index="' + i + '"]:checked', wrap);
        return c ? c.value : null;
      });
    }
    function find(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var opts = selected();
      opts.forEach(function (val, i) {
        var lbl = qs('[data-option-value="' + i + '"]', wrap);
        if (lbl) lbl.textContent = val || '';
      });
      /* mark sizes unavailable for the chosen colour */
      qsa('input[data-option-index]', wrap).forEach(function (inp) {
        var i = parseInt(inp.getAttribute('data-option-index'), 10);
        var test = opts.slice(); test[i] = inp.value;
        var v = find(test);
        inp.classList.toggle('is-unavailable', !v || !v.available);
      });
      var v = find(opts);
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = AB.t.unavailable; } return; }
      idInput.value = v.id;
      var label = v.available ? AB.t.add + ' · ' + fmt(v.price) : AB.t.soldOut;
      if (btn) { btn.disabled = !v.available; btn.textContent = label; }
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = label; }
      if (priceEl) priceEl.innerHTML = v.compare_at_price > v.price ? '<span class="ab-price--sale">' + fmt(v.price) + '</span> <s>' + fmt(v.compare_at_price) + '</s>' : fmt(v.price);
      if (stock) {
        stock.className = v.available ? 'ab-stock' : 'ab-stock ab-stock--low';
        stock.textContent = v.available ? AB.t.inStock : AB.t.soldOut;
      }
      if (v.featured_media) {
        var m = qs('[data-media-id="' + v.featured_media.id + '"]', wrap.closest('.ab-pdp') || document);
        var g = m && m.parentElement;
        if (m && g && g.firstElementChild !== m) g.insertBefore(m, g.firstElementChild);
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    wrap.addEventListener('change', function (e) { if (e.target.matches('input[data-option-index]')) update(); });
    update();

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      var bar = stickyBtn.closest('.ab-sticky-atc');
      if ('IntersectionObserver' in window && btn && bar) {
        new IntersectionObserver(function (en) {
          en[0].isIntersecting ? bar.removeAttribute('data-show') : bar.setAttribute('data-show', '');
        }).observe(btn);
      }
    }
  });

  /* ---------- size guide unit toggle ---------- */
  document.addEventListener('click', function (e) {
    var u = e.target.closest('[data-unit]');
    if (!u) return;
    var box = u.closest('[data-size-guide]');
    if (!box) return;
    var unit = u.getAttribute('data-unit');
    qsa('[data-unit]', box).forEach(function (b) { b.setAttribute('aria-pressed', b === u ? 'true' : 'false'); });
    qsa('[data-cm]', box).forEach(function (td) {
      var cm = parseFloat(td.getAttribute('data-cm'));
      td.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : td.getAttribute('data-cm');
    });
    qsa('[data-unit-label]', box).forEach(function (s) { s.textContent = unit; });
  });

  /* ---------- collection filters: auto-submit ---------- */
  qsa('form[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });
})();

/* product recommendations (complementary + related) */
(function () {
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (el.querySelector('.ab-grid')) return;
    var url = el.getAttribute('data-url');
    var go = function () {
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '600px 0px' });
      io.observe(el);
    } else { go(); }
  });
})();
